import { Button, Dialog, DialogHeader, DialogFooter, DialogBody, Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'

type SessionExpiredDialogProps = {
  open: boolean
  onClose: () => void
}

const SessionExpiredDialog = ({ open, onClose }: SessionExpiredDialogProps) => {
  const { t } = useTranslation()
  return (
    <Dialog size="lg" open={open} handler={onClose} className="font-barlow">
      <DialogHeader>{t('auth.sessionExpiredTitle')}</DialogHeader>
      <DialogBody>
        <Typography variant="h6" className="font-bold">
          {t('auth.sessionExpiredMessage')}
        </Typography>
      </DialogBody>

      <DialogFooter>
        <div className="w-full flex justify-center">
          <Button
            onClick={onClose}
            aria-label={t('auth.sessionExpiredAction')}
            data-testid="session-expired-dismiss-btn"
          >
            {t('auth.sessionExpiredAction')}
          </Button>
        </div>
      </DialogFooter>
    </Dialog>
  )
}

export default SessionExpiredDialog
